import CompanyNameSearch from './CompanyNameSearch';

export default CompanyNameSearch;
